var _path, _path2, _circle, _path3, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneOfTwo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 60,
    viewBox: "0 0 346 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 31L304 31",
    stroke: "#D9D9D9",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 31H174",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7244 42V23.168L24.4044 25.808V21.552L28.7244 18.96H32.6604V42H28.7244Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 30,
    r: 24,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.683 40.986L314.697 38.382L323.475 30.514C324.185 29.8887 324.665 29.2913 324.917 28.722C325.179 28.1527 325.309 27.5833 325.309 27.014C325.309 26.2953 325.151 25.6513 324.833 25.082C324.516 24.5033 324.077 24.046 323.517 23.71C322.957 23.374 322.313 23.206 321.585 23.206C320.839 23.206 320.171 23.3833 319.583 23.738C319.005 24.0833 318.552 24.5453 318.225 25.124C317.899 25.7027 317.74 26.328 317.749 27H314.753C314.753 25.6933 315.047 24.55 315.635 23.57C316.233 22.5807 317.049 21.8107 318.085 21.26C319.121 20.7 320.307 20.42 321.641 20.42C322.911 20.42 324.049 20.7093 325.057 21.288C326.065 21.8573 326.859 22.6413 327.437 23.64C328.025 24.6387 328.319 25.7773 328.319 27.056C328.319 27.98 328.198 28.764 327.955 29.408C327.713 30.052 327.349 30.6493 326.863 31.2C326.378 31.7507 325.771 32.348 325.043 32.992L318.267 39.04L317.945 38.2H328.319V40.986H314.683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOfTwo);
export default __webpack_public_path__ + "static/media/one_of_two.e47d39dfa992173f095792645a44acb1.svg";
export { ForwardRef as ReactComponent };